import { UI_CONFIG } from "../config/ui";
import en from "../i18n/en.json";

export type Locale = "en";
export type Dict = Record<string, string>;

const dictionaries: Record<Locale, Dict> = { en: en as Dict };

export function getInitialLocale(): Locale {
  const raw = localStorage.getItem(UI_CONFIG.storageKeys.locale);
  if (raw === "en") return "en";
  return "en";
}

export function setLocale(locale: Locale) {
  localStorage.setItem(UI_CONFIG.storageKeys.locale, locale);
}

export function t(locale: Locale, key: string, vars?: Record<string, string>): string {
  const dict = dictionaries[locale] ?? dictionaries.en;
  let str = dict[key] ?? key;
  if (vars) {
    Object.entries(vars).forEach(([k, v]) => {
      str = str.replace(`{${k}}`, v);
    });
  }
  return str;
}
